import {Injectable} from "@angular/core";
import {HandlerError, HttpErrorHandlerService} from "../../../core/services/http-error-handler.service";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {catchError, Observable} from "rxjs";
import {BaseResponse} from "../../../core/models/base-response";

@Injectable({
  providedIn: 'root'
})
export class AudienciaService {
  private handlerErro: HandlerError;

  constructor(
    private http: HttpClient,
    httpErrorHandler: HttpErrorHandlerService) {
    this.handlerErro = httpErrorHandler.createHandleError(`AudienciaService`);
  }

  baseUrl = environment.apiUrl;

  buscarPorData(dataInicial: string, dataFinal: string): Observable<BaseResponse<any[]> | BaseResponse<any>> {
    return this.http
      .get<BaseResponse<any[]>>(`${this.baseUrl}/Audiencia/BuscarPorData/${dataInicial}/${dataFinal}`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('buscarPorData')));
  }

  buscarPorOrigem(): Observable<BaseResponse<any[]> | BaseResponse<any>> {
    return this.http
      .get<BaseResponse<any[]>>(`${this.baseUrl}/Audiencia/PorOrigem`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('buscarPorOrigem')));
  }

  selecionarPorId(id: number): Observable<BaseResponse<any> | BaseResponse<any>> {
    return this.http
      .get<BaseResponse<any>>(`${this.baseUrl}/Audiencia/${id}`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('selecionarPorId')));
  }

  excluir(id: number): Observable<BaseResponse<boolean> | BaseResponse<any>> {
    return this.http
      .delete<BaseResponse<boolean>>(`${this.baseUrl}/Audiencia/${id}`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('excluir')));
  }

  buscarPorProcesso(processoId: number): Observable<BaseResponse<any[]> | BaseResponse<any>> {
    return this.http
      .get<BaseResponse<any[]>>(`${this.baseUrl}/Audiencia/BuscarPorProcesso/${processoId}`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('buscarPorProcesso')));
  }

  adicionar(audiencia: any): Observable<BaseResponse<boolean> | BaseResponse<any>> {
    return this.http
      .post<BaseResponse<boolean>>(`${this.baseUrl}/Audiencia`, audiencia)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('adicionar')));
  }

  alterar(audiencia: any): Observable<BaseResponse<boolean> | BaseResponse<any>> {
    return this.http
      .put<BaseResponse<boolean>>(`${this.baseUrl}/Audiencia`, audiencia)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('alterar')));
  }

  cancelar(id: number): Observable<BaseResponse<boolean> | BaseResponse<any>> {
    return this.http
      .patch<BaseResponse<boolean>>(`${this.baseUrl}/Audiencia/Cancelar/${id}`, {})
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('cancelar')));
  }

  finalizar(id: number): Observable<BaseResponse<boolean> | BaseResponse<any>> {
    return this.http
      .patch<BaseResponse<boolean>>(`${this.baseUrl}/Audiencia/Finalizar/${id}`, {})
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('finalizar')));
  }
}
